import { Component, OnInit } from '@angular/core';
import { BaseDynamicViewComponent } from 'src/app/common/components/dynamic-view-v2/components/base-dynamic-form/base-dynamic-view.component';
import { DynamicCardType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicCardType';
import { DynamicViewType } from 'src/app/common/components/dynamic-view-v2/enums/DynamicViewType';
import BaseEntityDto from 'src/app/common/dtos/BaseEntityDto';
import { BaseViewFieldType } from 'src/app/common/components/dynamic-view-v2/enums/BaseViewFieldType';

@Component({
  selector: 'app-qa-user-groups-views-v2',
  templateUrl: './qa-user-groups-views-v2.component.html',
  styleUrls: ['./qa-user-groups-views-v2.component.sass']
})
export class QAUserGroupsViewV2Component  extends BaseDynamicViewComponent implements OnInit
{
  qaUserGroupRecord: BaseEntityDto = new BaseEntityDto();
  constructor()
  {
    super();
  }

  /**
   * Titles View V2 Initial Implementation
   */
  ngOnInit()
  {
    this.fields =
    [
      {
        title: "QA User Group Details",
        fields:
        [
          { 
            name: "Name", 
            inputType: DynamicViewType.BaseViewField , 
            viewTypes: [BaseViewFieldType.Text], 
            clearField: true, 
            key: 'name', 
            isRequired: true, 
            label: 'Name' 
          },
          {
            name: "QA Users",
            inputType: DynamicViewType.BaseViewField , 
            viewTypes: [BaseViewFieldType.MultiSelectObj],
            clearField: true,
            key: 'users_ref',
            label: 'QA Users',
            controller: 'qa-users',
            columnWidth: 6
          },
        ],
        type: DynamicCardType.Card
      },
    ]
    // This will help us to define fields
    // with pre-established values.
    // This is just an example, there is no
    // need to add it if it's not necessary.
    this.qaUserGroupRecord =
    {
      enabled: false
    };
    this.title = "QA User Group";
    this.viewRoute = 'qa-user-groups-v2';
    this.isLoading = false;
  }

}
